import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '@core/services/profile.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@core/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonService } from '@core/services/common.service';
@Component({
    selector: 'app-update-mobile-check-pin',
    templateUrl: './update-mobile-check-pin.component.html',
    styleUrls: ['./update-mobile-check-pin.component.scss'],
    standalone: false
})
export class UpdateMobileCheckPINComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('UpdateMobileCheckPIN') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    isSuccess: boolean = false;

    form: FormGroup;

    private mobile: string | null;
    private smsCode: string | null = null;

    constructor(
        private commonService: CommonService,
        private dialogService: NxDialogService,
        private profileService: ProfileService,
        private translateService: TranslateService,
        private alertService: AlertService
    ) {
        this.form = new FormGroup({
            smsCode: new FormControl(this.smsCode, Validators.required)
        });
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, {
            showCloseIcon: false,
        });
        //this.modalDialogRef.beforeClosed().subscribe(() => this.confirm.next(new SubmitEvent('submit')));
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData(inputData?: any): void {
        this.mobile = inputData?.mobile;
        this.smsCode = inputData?.smsCode;
        this.form.get('smsCode').setValue(this.smsCode)
    }

    resend() {
        if (!this.mobile) {
            this.translateService.get('error.service-call-fail').subscribe(trans => {
                this.alertService.error(trans);
            });
            return;
        }
        this.profileService.generateSMSCode(this.mobile, 'update_profile_mobile').subscribe({
                    error: (errorResponse: HttpErrorResponse) => {
                        if(errorResponse.error['msg'] == 'attemptsExceeded'){
                            this.translateService.get('error.sms.wait').subscribe( (trans) => {
                                this.alertService.error(trans);
                            })
                        }
                    },
                    next: (response) => {
                        const smsCode = response['pin'] ? response['pin'] : null
                        this.form.get('smsCode').setValue(smsCode);
                    }
                });
    }

    checkSMSCode() {
        if (this.form.invalid) {
            return;
        }

        this.profileService.validateSMSCode(this.form.controls.smsCode.value, 'update_profile_mobile').subscribe(() => {
            this.isSuccess = true;
            this.confirm.next(new SubmitEvent('submit'));
            this.closeModal();
        });
    }

    isRed() {
        return this.commonService.env != 'prod' ? 'color-red': '';
    }
}
